export const formChannels = [
  ['direct', 'مباشر'], ['website', 'الموقع'], ['tamkeen_intro', 'صفحة التعريف بالتمكين'], ['whatsapp', 'واتساب'],
  ['facebook', 'فيسبوك'], ['instagram', 'إنستغرام'], ['tiktok', 'تيك توك'],
  ['youtube', 'يوتيوب'], ['telegram', 'تلغرام'], ['x', 'إكس'],
  ['linkedin', 'لينكدإن'], ['snapchat', 'سناب شات'], ['staff', 'الموظفون'],
  ['college', 'الكلية'], ['university', 'الجامعة'], ['mosque', 'المسجد'],
  ['street_poster', 'ملصق الشارع'],
  ['mosques', 'المساجد'], ['university_college', 'الجامعات والكليات'],
  ['street_posters', 'ملصقات الشوارع'], ['other', 'أخرى'],
];
export const channelLabel = key => formChannels.find(([value]) => value === key)?.[1] || (key || 'غير معروف (سجلات سابقة)');
export function normalizeChannelKey(value) {
  const key = typeof value === 'string' ? value.trim().toLowerCase().replace(/[\s-]+/g, '_') : '';
  if (key.length > 64 || !/^[a-z0-9]+(?:_[a-z0-9]+)*$/.test(key)) return '';
  if (key === 'twitter') return 'x';
  if (key === 'wa') return 'whatsapp';
  if (key === 'posters') return 'street_posters';
  return key;
}
export function submissionToken(cryptoProvider = window.crypto) {
  if (cryptoProvider.randomUUID) return cryptoProvider.randomUUID();
  return Array.from(cryptoProvider.getRandomValues(new Uint8Array(16)), byte => byte.toString(16).padStart(2, '0')).join('');
}
export function attributionQuery(search) {
  const input = new URLSearchParams(search);
  const result = new URLSearchParams();
  for (const key of ['channel', 'campaign']) {
    if (input.has(key)) result.set(key, input.get(key).slice(0, key === 'channel' ? 64 : 80));
  }
  return result.toString();
}
export function registrationViewQuery(search, requiredOnly) {
  const query = new URLSearchParams(search);
  if (requiredOnly) query.set('view', 'required');
  else query.delete('view');
  return query.toString();
}
export function formShareUrl(form, channel, campaign, origin, requiredOnly = false) {
  const key = normalizeChannelKey(channel);
  if (!key) throw new Error('Invalid channel key');
  const path = form.shortId ? `/f/${encodeURIComponent(form.shortId)}` : `/register/${encodeURIComponent(form.slug)}`;
  const query = new URLSearchParams({ channel: key, ...(campaign.trim() ? { campaign: campaign.trim().slice(0, 80) } : {}) });
  return `${origin}${path}?${registrationViewQuery(query, requiredOnly)}`;
}